import { defineNuxtPlugin } from 'nuxt/app'
// import vWebp from '~/directives/v-webp'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (err: any, instance, info) => {
    // [SSR] 服务端必须重抛：否则页面级 createError（语义 URL 404 守卫 pipeline）
    // 会被吞掉，渲染继续返回 200。生产环境另由 server/middleware/00-fairSemanticBizGuard.ts
    // 在 h3 层拦截 404（Vue errorHandler 重抛在 prod 构建仍会被二次吞掉）。
    if (process.server) {
      console.error('7007-7007-全局错误(服务端重抛)', err)
      throw err
    }
    // 处理错误
    // console.error(err, instance, info)
    console.error('7007-7007-全局错误', err)
    console.log(err?.message)
    if (err?.message?.includes('503')) {
      if (process.client && 'fundebug' in window) {
        // ;(window as any).fundebug.notifyError(error)
        ;(window as any).fundebug.notifyError(err)
      }
    }
    // console.log(typeof err)
    // console.log(String(err))
    // ElMessage({
    //   message: `7007-7007-${String(err)}`,
    //   type: 'error',
    //   customClass: 'hello_message'
    // })
  }
})
